// 공통 코드 관련 API 함수 (tb_code_master)
import axiosInstance from './axiosInstance';

// 코드타입 목록 조회 (DISTINCT code_type)
export const fetchCodeTypes = async () => {
  const response = await axiosInstance.get('/codes/types');
  return response.data.data;  // [{ code_type, label }, ...]
};

// 전체 코드 목록 조회
export const fetchAllCodes = async () => {
  const response = await axiosInstance.get('/codes');
  return response.data.data;
};

// 코드타입별 목록 조회
export const fetchCodesByType = async (codeType) => {
  const response = await axiosInstance.get(`/codes/${codeType}`);
  return response.data.data;
};

// 코드 등록
export const createCode = async (payload) => {
  const response = await axiosInstance.post('/codes', payload);
  return response.data;
};

// 코드 수정
export const updateCode = async (id, payload) => {
  const response = await axiosInstance.put(`/codes/${id}`, payload);
  return response.data;
};

// 코드 삭제
export const deleteCode = async (id) => {
  const response = await axiosInstance.delete(`/codes/${id}`);
  return response.data;
};

// admin 코드 가져오기 (현재 사용자의 해당 code_type 코드를 admin 코드로 전체 교체)
export const copyFromAdmin = async (codeType) => {
  const response = await axiosInstance.post('/codes/copy-from-admin', { code_type: codeType });
  return response.data;
};
